module.exports = __webpack_public_path__ + "img/cjgl@2x.d6050be0.png";